<template>
  <v-container class="mx-0 pa-0 ">
    <v-card class="com-pc-card vc-point-card">
      <!-- 周辺観測所 -->
      <div>
        <v-row class="com-pc-card-header vc-card-header">
          <span class="com-pc-card-title vc-card-title"
            >{{ editSelectedPointName }}{{ text.title }}</span
          >
          <v-spacer></v-spacer>
          <v-btn
            v-if="selectedPoint && selectedPoint.address"
            outlined
            x-small
            color="white"
            class="vc-btn mr-2"
            @click="addTm()"
          >
            <span>{{ text.add }}</span>
          </v-btn>
        </v-row>
      </div>
      <div class="vc-list com-pc-card-contents">
        <div
          v-if="
            (!tmPoint || tmPoint.length === 0) &&
              (!cctvPoint || cctvPoint.length === 0) &&
              (!swPoint || swPoint.length === 0) &&
              (!swcctvPoint || swcctvPoint.length === 0) &&
              (!scamPoint || scamPoint.length === 0)
          "
        >
          <v-col class="vc-message">
            {{ this.$store.state.app.config.messageConfig.vcNoRegist }}
          </v-col>
        </div>
        <v-simple-table
          v-if="
            (tmPoint && tmPoint.length > 0) ||
              (cctvPoint && cctvPoint.length > 0) ||
              (swPoint && swPoint.length > 0) ||
              (swcctvPoint && swcctvPoint.length > 0) ||
              (scamPoint && scamPoint.length > 0)
          "
          light
          fixed-header
        >
          <thead v-if="selectedPoint">
            <tr>
              <th class="vc-item-name pr-0">{{ text.obName }}</th>
              <th class="vc-item-river px-1">{{ text.rvName }}</th>
              <th class="vc-item-distance pa-0">{{ text.distance }}</th>
              <th class="vc-item-clear">{{ text.delete }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- 周辺観測所 -->
            <tr
              v-for="(list, idxTm) in tmPoint"
              :key="'tm_' + idxTm"
              class="vc-line point-data"
            >
              <td class="vc-item-name pr-0">
                <v-row>
                  <div class="pl-1 pr-1 vc-item-icon">
                    <img
                      v-if="list.itmkndCd == 1"
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_rain.svg"
                    />
                    <img
                      v-if="list.itmkndCd == 3"
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_snow.svg"
                    />
                    <img
                      v-if="list.itmkndCd == 4"
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_water.svg"
                    />
                    <img
                      v-if="list.itmkndCd == 6"
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_quality.svg"
                    />
                    <img
                      v-if="list.itmkndCd == 7"
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_dam.svg"
                    />
                    <img
                      v-if="list.itmkndCd == 12"
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_sea.svg"
                    />
                  </div>
                  <div class="obs-name">{{ list.name }}</div>
                </v-row>
              </td>
              <td class="vc-item-river pa-0">{{ list.riverName }}</td>
              <td class="vc-item-distance pa-0">{{ list.distance }} km</td>

              <td class="vc-item-clear">
                <v-btn
                  fab
                  outlined
                  x-small
                  color="success"
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="deleteTm(idxTm)"
                  :class="{
                    'mt-3 mb-3': !(list.itmkndCd == 1 || list.itmkndCd == 4),
                  }"
                >
                  <v-icon small>clear</v-icon>
                </v-btn>
              </td>
            </tr>
            <!-- 危機管理型水位計 -->
            <tr
              v-for="(list, idxSw) in swPoint"
              :key="'sw_' + idxSw"
              class="vc-line point-data"
            >
              <td class="vc-item-name pr-0">
                <v-row>
                  <div class="pl-1 pr-1 vc-item-icon">
                    <img
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_swstg.svg"
                    />
                  </div>
                  <div class="obs-name">{{ list.swobsNm }}</div>
                </v-row>
              </td>
              <td class="vc-item-river pa-0">{{ list.swrvrNm }}</td>
              <td class="vc-item-distance pa-0">{{ list.distance }} km</td>

              <td class="vc-item-clear">
                <v-btn
                  fab
                  outlined
                  x-small
                  color="success"
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="deleteSw(idxSw)"
                >
                  <v-icon small>clear</v-icon>
                </v-btn>
              </td>
            </tr>
            <!-- 周辺簡易カメラ -->
            <tr
              v-for="(list, idxScam) in scamPoint"
              :key="'scam_' + idxScam"
              class="vc-line point-data"
            >
              <td class="vc-item-name pr-0">
                <v-row>
                  <div class="pl-1 pr-1 vc-item-icon">
                    <img
                      class="vc-icon"
                      src="/kawabou/img/obs_icons/obs_camera.svg"
                    />
                  </div>
                  <div class="obs-name">{{ list.name }}</div>
                </v-row>
              </td>
              <td class="vc-item-river pa-0">{{ list.rvrNm }}</td>
              <td class="vc-item-distance  pa-0">{{ list.distance }} km</td>
              <!-- <td class="vc-item-notice"></td> -->
              <td class="vc-item-clear">
                <v-btn
                  fab
                  outlined
                  x-small
                  color="success"
                  :disabled="editFlag !== 0 && editLocationMode !== 1"
                  @click="deleteScam(idxScam)"
                  class="mt-3 mb-3"
                >
                  <v-icon small>clear</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card>
  </v-container>
</template>
<script>
import mixin from "./../../lib/mixin.js";
import WebStorage from "./../../lib/webStorage.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "vc-tm-list",
  mixins: [mixin],
  data() {
    return {
      riskDate: "",
      points: [{}, {}, {}],
      text: {
        title: "周辺の観測所一覧",
        obName: "観測所名",
        rvName: "河川名",
        distance: "距離",
        notice: "通知",
        notification: "通知は...",
        delete: "削除",
        add: "観測所追加",
        help:
          "地点登録すると、地図上にホームアイコンが表示され、" +
          "影響のある河川の水位情報や浸水の影響度合いを見ることができます。",
        // "また、周辺の観測所ごとに通知設定を入れると、" +
        // "ホームアイコンやデスクトップ等で通知を受けることができます。",
      },
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[VcTmList] mounted()");
    this.init();
  },
  computed: {
    /** 選択地点インデックス */
    selectedPointIndex: {
      get() {
        return this.$store.state.viewConfig.selectedPoint;
      },
    },
    /** 選択地点 */
    selectedPoint: {
      get() {
        if (this.selectedPointIndex === "") {
          return "";
        } else {
          return this.points[this.$store.state.viewConfig.selectedPoint];
        }
      },
    },
    /** 選択CCTVリスト */
    cctvPoint: {
      get() {
        if (this.selectedPoint && this.selectedPoint.tmDatas) {
          return this.selectedPoint.tmDatas.cctvPoint;
        } else {
          return [];
        }
      },
    },
    /** 選択TMリスト */
    tmPoint: {
      get() {
        if (this.selectedPoint && this.selectedPoint.tmDatas) {
          return this.selectedPoint.tmDatas.tmPoint;
        } else {
          return [];
        }
      },
    },
    /** 選択危機カメラリスト */
    swcctvPoint: {
      get() {
        if (this.selectedPoint && this.selectedPoint.tmDatas) {
          return this.selectedPoint.tmDatas.swcctvPoint;
        } else {
          return [];
        }
      },
    },
    /** 選択簡易カメラリスト */
    scamPoint: {
      get() {
        if (this.selectedPoint && this.selectedPoint.tmDatas) {
          return this.selectedPoint.tmDatas.scamPoint;
        } else {
          return [];
        }
      },
    },
    /** 選択SWリスト */
    swPoint: {
      get() {
        if (this.selectedPoint && this.selectedPoint.tmDatas) {
          return this.selectedPoint.tmDatas.swPoint;
        } else {
          return [];
        }
      },
    },
    /** 選択地点名 */
    editSelectedPointName: {
      get() {
        if (this.selectedPointIndex === "") {
          return "";
        } else {
          let name = this.selectedPoint.name;
          if (!name) {
            return "「地点" + (this.selectedPointIndex + 1) + "」";
          } else {
            if (name.length > 15) {
              name = name.substring(0, 15) + "...";
            }
            return "「" + name + "」の";
          }
        }
      },
    },
    dispPoint: {
      get() {
        if (this.selectedPointIndex === "") {
          return false;
        } else {
          return true;
        }
      },
    },
    /** 登録地点読み込み日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 登録地編集モード [0:未編集, 1:地図選択, 2:登録確認] */
    editLocationMode: {
      get() {
        return this.$store.state.map.editLocationMode;
      },
    },
    /** 登録中フラグ */
    editFlag: {
      get() {
        return this.$store.state.map.editFlag;
      },
    },
    /** 選択地点名 */
    selectedPointName: {
      get() {
        return this.$store.state.viewConfig.selectedPointName;
      },
    },
  },
  watch: {
    /** 地図の登録地点が読み直された場合、コンポーネントも再表示 */
    editWebStorageDate() {
      this.$log.debug("[VcTmList] editWebStorageDate()");
      this.$store.commit("map/setEditFlag", 0);
      this.init();
    },
    /** 登録中フラグ */
    editFlag() {
      this.$log.debug("[VcTmList] editFlag()");
      if (this.editFlag === 0) {
        this.editDefault();
      }
    },
  },
  methods: {
    /** 表示項目初期化 */
    init() {
      this.$log.debug("[VcTmList] init()");
      // webストレージから表示情報を取得
      let point1 = WebStorage.getPoint1Info();
      this.$log.debug("[VcTmList] init() point1");
      this.$log.dir(point1);
      let point2 = WebStorage.getPoint2Info();
      this.$log.debug("[VcTmList] init() point2");
      this.$log.dir(point2);
      let point3 = WebStorage.getPoint3Info();
      this.$log.debug("[VcTmList] init() point3");
      this.$log.dir(point3);
      let point4 = WebStorage.getPoint4Info();
      this.$log.debug("[VcTmList] init() point4");
      this.$log.dir(point4);
      let point5 = WebStorage.getPoint5Info();
      this.$log.debug("[VcTmList] init() point5");
      this.$log.dir(point5);
      this.points = [
        point1 ? point1 : { tmDatas: [] },
        point2 ? point2 : { tmDatas: [] },
        point3 ? point3 : { tmDatas: [] },
        point4 ? point4 : { tmDatas: [] },
        point5 ? point5 : { tmDatas: [] },
      ];
      this.$log.debug("[VcTmList] init() points");
      this.$log.dir(this.points);
    },
    /** 通知変更時 */
    changeNotice() {
      this.$log.debug("[VcTmList] changeNotice()");
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug("[VcTmList] changeNotice selectedPoint == 0");
          WebStorage.setPoint1Info(this.selectedPoint);
          break;
        case 1:
          this.$log.debug("[VcTmList] changeNotice selectedPoint == 1");
          WebStorage.setPoint2Info(this.selectedPoint);
          break;
        case 2:
          this.$log.debug("[VcTmList] changeNotice selectedPoint == 2");
          WebStorage.setPoint3Info(this.selectedPoint);
          break;
        case 3:
          this.$log.debug("[VcTmList] changeNotice selectedPoint == 3");
          WebStorage.setPoint4Info(this.selectedPoint);
          break;
        case 4:
          this.$log.debug("[VcTmList] changeNotice selectedPoint == 4");
          WebStorage.setPoint5Info(this.selectedPoint);
          break;
      }
      // 通知情報の変更をDBに反映
      this.$store.dispatch("Telemeter/changeNotice", {
        pointNo: this.$store.state.viewConfig.selectedPoint,
        token: this.$store.state.app.token,
        selectedPoint: this.selectedPoint,
      });
    },
    /** 選択TM削除 */
    deleteTm(index) {
      this.$log.debug("[VcTmList] deleteTm(" + index + ")");
      this.selectedPoint.tmDatas.tmPoint.splice(index, 1);
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug("[VcTmList] deleteTm selectedPoint == 0");
          WebStorage.setPoint1Info(this.selectedPoint);
          break;
        case 1:
          this.$log.debug("[VcTmList] deleteTm selectedPoint == 1");
          WebStorage.setPoint2Info(this.selectedPoint);
          break;
        case 2:
          this.$log.debug("[VcTmList] deleteTm selectedPoint == 2");
          WebStorage.setPoint3Info(this.selectedPoint);
          break;
        case 3:
          this.$log.debug("[VcTmList] deleteTm selectedPoint == 3");
          WebStorage.setPoint4Info(this.selectedPoint);
          break;
        case 4:
          this.$log.debug("[VcTmList] deleteTm selectedPoint == 4");
          WebStorage.setPoint5Info(this.selectedPoint);
          break;
      }
      // 通知情報の変更をDBに反映
      this.$store.dispatch("Telemeter/changeNotice", {
        pointNo: this.$store.state.viewConfig.selectedPoint,
        token: this.$store.state.app.token,
        selectedPoint: this.selectedPoint,
      });

      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 選択危機管理型水位計削除 */
    deleteSw(index) {
      this.$log.debug("[VcTmList] deleteSw(" + index + ")");
      this.selectedPoint.tmDatas.swPoint.splice(index, 1);
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug("[VcTmList] deleteSw selectedPoint == 0");
          WebStorage.setPoint1Info(this.selectedPoint);
          break;
        case 1:
          this.$log.debug("[VcTmList] deleteSw selectedPoint == 1");
          WebStorage.setPoint2Info(this.selectedPoint);
          break;
        case 2:
          this.$log.debug("[VcTmList] deleteSw selectedPoint == 2");
          WebStorage.setPoint3Info(this.selectedPoint);
          break;
        case 3:
          this.$log.debug("[VcTmList] deleteSw selectedPoint == 3");
          WebStorage.setPoint4Info(this.selectedPoint);
          break;
        case 4:
          this.$log.debug("[VcTmList] deleteSw selectedPoint == 4");
          WebStorage.setPoint5Info(this.selectedPoint);
          break;
      }

      // 通知情報の変更をDBに反映
      this.$store.dispatch("Telemeter/changeNotice", {
        pointNo: this.$store.state.viewConfig.selectedPoint,
        token: this.$store.state.app.token,
        selectedPoint: this.selectedPoint,
      });

      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 選択簡易カメラ削除 */
    deleteScam(index) {
      this.$log.debug("[VcTmList] deleteScam(" + index + ")");
      this.selectedPoint.tmDatas.scamPoint.splice(index, 1);
      switch (this.$store.state.viewConfig.selectedPoint) {
        case 0:
          this.$log.debug("[VcTmList] deleteScam selectedPoint == 0");
          WebStorage.setPoint1Info(this.selectedPoint);
          break;
        case 1:
          this.$log.debug("[VcTmList] deleteScam selectedPoint == 1");
          WebStorage.setPoint2Info(this.selectedPoint);
          break;
        case 2:
          this.$log.debug("[VcTmList] deleteScam selectedPoint == 2");
          WebStorage.setPoint3Info(this.selectedPoint);
          break;
        case 3:
          this.$log.debug("[VcTmList] deleteScam selectedPoint == 3");
          WebStorage.setPoint4Info(this.selectedPoint);
          break;
        case 4:
          this.$log.debug("[VcTmList] deleteScam selectedPoint == 4");
          WebStorage.setPoint5Info(this.selectedPoint);
          break;
      }
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
    /** 初期表示設定 */
    editDefault() {
      this.$log.debug("[VcTmList] editDefault");
      // webストレージから取得
      let info = WebStorage.getDefaultInfo();
      let point1 = WebStorage.getPoint1Info();
      let point2 = WebStorage.getPoint2Info();
      let point3 = WebStorage.getPoint3Info();
      let point4 = WebStorage.getPoint4Info();
      let point5 = WebStorage.getPoint5Info();
      if (point1 && this.selectedPointIndex === 0) {
        info.point1 = true;
        info.point2 = false;
        info.point3 = false;
        info.point4 = false;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point2 && this.selectedPointIndex === 1) {
        info.point1 = false;
        info.point2 = true;
        info.point3 = false;
        info.point4 = false;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point3 && this.selectedPointIndex === 2) {
        info.point1 = false;
        info.point2 = false;
        info.point3 = true;
        info.point4 = false;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point4 && this.selectedPointIndex === 3) {
        info.point1 = false;
        info.point2 = false;
        info.point3 = false;
        info.point4 = true;
        info.point5 = false;
        info.pointDefault = false;
      } else if (point5 && this.selectedPointIndex === 4) {
        info.point1 = false;
        info.point2 = false;
        info.point3 = false;
        info.point4 = false;
        info.point5 = true;
        info.pointDefault = false;
      }
      // webストレージ書き込み
      WebStorage.setDefaultInfo(info);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },

    /** 観測所追加時 */
    addTm() {
      this.$log.debug("[VcTmList] addTm()");
      // アクセスログ出力
      PageLog.log({
        page_log: "obsadd",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      let index = this.$store.state.viewConfig.selectedPoint;
      this.$store.commit("map/setEditTmMode", 1);
      this.$store.commit("viewConfig/setSelectedPoint", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-point-card {
  display: flex;
  flex-direction: column;
}
.vc-card-header {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.vc-message {
  font-size: 1rem;
}

.vc-btn {
  font-size: 0.9rem;
}

.vc-info {
  .vc-info-text {
    width: 300px;
    display: flex;
    flex-direction: row;

    .vc-info-title {
      width: 150px;
    }
    .vc-info-value {
      width: 150px;
    }
  }
}

.vc-tm-table-frame {
  background-color: #f0f;
}
.vc-icon {
  width: 26px;
}
.icon {
  margin-right: 4px;
}
.obs-name {
  margin-left: 6px;
  align-items: center;
  vertical-align: middle;
  width: 150px;
}
.vc-item-icon {
  width: 30px;
}
.vc-item-name {
  width: 295px;
}
.vc-item-river {
  width: 90px;
}
.vc-item-distance {
  width: 75px;
}
.vc-item-notice {
  width: 85px;
}
</style>
